import { clearBodyLocks } from 'tua-body-scroll-lock';
import { isIOSUserAgent } from '../common/utils/device';
import BaseModalSizeSelector from './components/BaseModalSizeSelector.vue';
import EventBusConfig from './config/eventBusConfig';
import { nameModalHtmlId, ITEMS } from './config/modalSizeSelectorConfig';
import store from './store';

let instance = null;
const getEvenBus = () => window.Vue.prototype.$eventBus;

function buildVueSelector() {
  let modalSelector = document.getElementById(nameModalHtmlId);
  if (!modalSelector) {
    modalSelector = document.createElement('div');
    modalSelector.id = nameModalHtmlId;
    document.body.appendChild(modalSelector);
  }
  modalSelector.innerHTML = '';
  const vueContainer = document.createElement('div');
  modalSelector.appendChild(vueContainer);
  return vueContainer;
}

function createInstance(data) {
  const element = buildVueSelector();
  const { Vue } = window;
  instance = new Vue({
    data: {
      currentItem: data.currentItem || ITEMS.LOADING,
      product: data.product,
      selectedSize: data.selectedSize || {},
    },
    render(h) {
      return h(BaseModalSizeSelector, {
        props: {
          ...data,
          currentItem: this.currentItem,
          product: this.product,
          selectedSize: this.selectedSize,
        },
        on: {
          closed,
          'size:change': changeSize,
          'stock-alert:hide': closedStockAlert,
        },
      });
    },
    store,
    router: Vue.prototype.$vuerouter,
  });
  instance.$mount(element);
}

function changeSize(size) {
  const EventBus = getEvenBus();
  EventBus.$emit(EventBusConfig.commands.modalSizeSelector.changeSize, {
    product: instance.$data.product,
    size,
  });
}

function closed() {
  const EventBus = getEvenBus();
  EventBus.$emit(EventBusConfig.commands.modalSizeSelector.closed, {
    currentItem: instance.$data.currentItem,
    product: instance.$data.product,
  });
}

function closedStockAlert() {
  const EventBus = getEvenBus();
  EventBus.$emit(EventBusConfig.commands.modalSizeSelector.closedStockAlert, {
    product: instance.$data.product,
  });
}

function removeInstance() {
  if (!instance) return;
  instance.$destroy();
  buildVueSelector();
  instance = null;
  document.body.classList.remove('base-modal-open');
  if (isIOSUserAgent()) {
    // Ensures all body locks are removed, due to lock posibly being called multiple times
    clearBodyLocks();
  }
}

function setProps({ currentItem, product = null, selectedSize = null }) {
  if (!instance) return;
  instance.$data.currentItem = currentItem || ITEMS.LOADING;
  if (selectedSize) instance.$data.selectedSize = selectedSize;
  if (product) instance.$data.product = product;
}

function initInstance() {
  const EventBus = getEvenBus();
  EventBus.$on(
    EventBusConfig.commands.modalSizeSelector.removeInstance,
    removeInstance
  );
  EventBus.$on(
    EventBusConfig.commands.modalSizeSelector.createInstance,
    createInstance
  );
  EventBus.$on(EventBusConfig.commands.modalSizeSelector.setProps, setProps);
}

export default initInstance;
export { nameModalHtmlId, ITEMS };
